/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * @hidden
 * Constants
 */
var Constants =
/** @class */
function () {
  function Constants() {}

  Object.defineProperty(Constants, "libraryName", {
    get: function get() {
      return "Msal.js";
    } // used in telemetry sdkName
    ,
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "claims", {
    get: function get() {
      return "claims";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "clientId", {
    get: function get() {
      return "clientId";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "adalIdToken", {
    get: function get() {
      return "adal.idtoken";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "cachePrefix", {
    get: function get() {
      return "msal";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "scopes", {
    get: function get() {
      return "scopes";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "no_account", {
    get: function get() {
      return "NO_ACCOUNT";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "upn", {
    get: function get() {
      return "upn";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "domain_hint", {
    get: function get() {
      return "domain_hint";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "prompt_select_account", {
    get: function get() {
      return "&prompt=select_account";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "prompt_none", {
    get: function get() {
      return "&prompt=none";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "prompt", {
    get: function get() {
      return "prompt";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "response_mode_fragment", {
    get: function get() {
      return "&response_mode=fragment";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "resourceDelimiter", {
    get: function get() {
      return "|";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "cacheDelimiter", {
    get: function get() {
      return ".";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "popUpWidth", {
    get: function get() {
      return this._popUpWidth;
    },
    set: function set(width) {
      this._popUpWidth = width;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "popUpHeight", {
    get: function get() {
      return this._popUpHeight;
    },
    set: function set(height) {
      this._popUpHeight = height;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "login", {
    get: function get() {
      return "LOGIN";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "renewToken", {
    get: function get() {
      return "RENEW_TOKEN";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "unknown", {
    get: function get() {
      return "UNKNOWN";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "homeAccountIdentifier", {
    get: function get() {
      return "homeAccountIdentifier";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "common", {
    get: function get() {
      return "common";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "openidScope", {
    get: function get() {
      return "openid";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "profileScope", {
    get: function get() {
      return "profile";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "interactionTypeRedirect", {
    get: function get() {
      return "redirectInteraction";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "interactionTypePopup", {
    get: function get() {
      return "popupInteraction";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "interactionTypeSilent", {
    get: function get() {
      return "silentInteraction";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Constants, "inProgress", {
    get: function get() {
      return "inProgress";
    },
    enumerable: true,
    configurable: true
  });
  Constants._popUpWidth = 483;
  Constants._popUpHeight = 600;
  return Constants;
}();

export { Constants };
/**
 * Keys in the hashParams
 */

export var ServerHashParamKeys;

(function (ServerHashParamKeys) {
  ServerHashParamKeys["SCOPE"] = "scope";
  ServerHashParamKeys["STATE"] = "state";
  ServerHashParamKeys["ERROR"] = "error";
  ServerHashParamKeys["ERROR_DESCRIPTION"] = "error_description";
  ServerHashParamKeys["ACCESS_TOKEN"] = "access_token";
  ServerHashParamKeys["ID_TOKEN"] = "id_token";
  ServerHashParamKeys["EXPIRES_IN"] = "expires_in";
  ServerHashParamKeys["SESSION_STATE"] = "session_state";
  ServerHashParamKeys["CLIENT_INFO"] = "client_info";
})(ServerHashParamKeys || (ServerHashParamKeys = {}));

;
/**
 * @hidden
 * CacheKeys for MSAL
 */

export var TemporaryCacheKeys;

(function (TemporaryCacheKeys) {
  TemporaryCacheKeys["AUTHORITY"] = "authority";
  TemporaryCacheKeys["ACQUIRE_TOKEN_ACCOUNT"] = "acquireTokenAccount";
  TemporaryCacheKeys["SESSION_STATE"] = "session.state";
  TemporaryCacheKeys["STATE_LOGIN"] = "state.login";
  TemporaryCacheKeys["STATE_ACQ_TOKEN"] = "state.acquireToken";
  TemporaryCacheKeys["STATE_RENEW"] = "state.renew";
  TemporaryCacheKeys["NONCE_IDTOKEN"] = "nonce.idtoken";
  TemporaryCacheKeys["LOGIN_REQUEST"] = "login.request";
  TemporaryCacheKeys["RENEW_STATUS"] = "token.renew.status";
  TemporaryCacheKeys["URL_HASH"] = "urlHash";
  TemporaryCacheKeys["INTERACTION_STATUS"] = "interaction_status";
  TemporaryCacheKeys["REDIRECT_REQUEST"] = "redirect_request";
})(TemporaryCacheKeys || (TemporaryCacheKeys = {}));

export var PersistentCacheKeys;

(function (PersistentCacheKeys) {
  PersistentCacheKeys["IDTOKEN"] = "idtoken";
  PersistentCacheKeys["CLIENT_INFO"] = "client.info";
})(PersistentCacheKeys || (PersistentCacheKeys = {}));

export var ErrorCacheKeys;

(function (ErrorCacheKeys) {
  ErrorCacheKeys["LOGIN_ERROR"] = "login.error";
  ErrorCacheKeys["ERROR"] = "error";
  ErrorCacheKeys["ERROR_DESC"] = "error.description";
})(ErrorCacheKeys || (ErrorCacheKeys = {}));

export var AADTrustedHostList = {
  "login.windows.net": "login.windows.net",
  "login.chinacloudapi.cn": "login.chinacloudapi.cn",
  "login.cloudgovapi.us": "login.cloudgovapi.us",
  "login.microsoftonline.com": "login.microsoftonline.com",
  "login.microsoftonline.de": "login.microsoftonline.de",
  "login.microsoftonline.us": "login.microsoftonline.us"
};
/**
 * @hidden
 * SSO Types - generated to populate hints
 */

export var SSOTypes;

(function (SSOTypes) {
  SSOTypes["ACCOUNT"] = "account";
  SSOTypes["SID"] = "sid";
  SSOTypes["LOGIN_HINT"] = "login_hint";
  SSOTypes["ID_TOKEN"] = "id_token";
  SSOTypes["ACCOUNT_ID"] = "accountIdentifier";
  SSOTypes["HOMEACCOUNT_ID"] = "homeAccountIdentifier";
})(SSOTypes || (SSOTypes = {}));

;
/**
 * @hidden
 */

export var BlacklistedEQParams = [SSOTypes.SID, SSOTypes.LOGIN_HINT];
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 * @hidden
 */

export var PromptState = {
  LOGIN: "login",
  SELECT_ACCOUNT: "select_account",
  CONSENT: "consent",
  NONE: "none"
};
/**
 * Frame name prefixes for the hidden iframe created in silent frames
 */

export var FramePrefix = {
  ID_TOKEN_FRAME: "msalIdTokenFrame",
  TOKEN_FRAME: "msalRenewFrame"
};
/**
 * MSAL JS Library Version
 */

export function libraryVersion() {
  return "1.3.2";
}